exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ActiveQuiz__ActiveQuiz--2aF-E{\r\n    color:#fff;\r\n    padding: 15px;\r\n    border:2px solid #fff;\r\n    box-sizing: border-box;\r\n    margin: 0 10px;\r\n    \r\n}\r\n\r\n.ActiveQuiz__Question--1DBQp{\r\n    display: flex;\r\n    justify-content: space-between;\r\n    font-size: 14px;\r\n}\r\n\r\n.ActiveQuiz__Question--1DBQp span{\r\n    max-width: 450px;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"ActiveQuiz": "ActiveQuiz__ActiveQuiz--2aF-E",
	"Question": "ActiveQuiz__Question--1DBQp"
};